import React, { useState } from 'react';
import ComplianceSection from './ComplianceSection';
import { IPilotSummary } from '../../type/pilotSummary';
import { formatDateToDDMMYYYY, getAdjustedDate } from '../../utils/dateUtils';
import { COMPLIANCE_STATUS } from '../../constants/constant';

type Props = {
  data: IPilotSummary[];
  driverAccordionIsOpen?: boolean;
};

export type Staff = {
  name: string;
  staffId: number;
  contactStaffId: number;
};
// const ComplianceSection: React.FC<Props> = (
const PilotSummary: React.FC<Props> = ({ data, driverAccordionIsOpen }) => {
  const [isEditMode, setEditMode] = useState(false);
  const [updatedAllocations, setUpdatedAllocations] = useState<{
    [key: number]: number;
  }>({});
  const [isEdit] = useState<boolean>(true);

  const aircraftRows = data?.map((item) => {
    return [
      item?.staffName,
      <td
        className={` ${
            item?.restStyle === COMPLIANCE_STATUS.expired
            ? 'text-red-700'
            : item?.restStyle === COMPLIANCE_STATUS.upcoming || item?.restStyle === COMPLIANCE_STATUS.current
              ? 'text-yellow-500'
              :item?.restStyle ||item?.restStyle ==COMPLIANCE_STATUS.compliant? 'text-green'
              : 'text-gray-700'
              }`}
            >
              {item.restDays}
        </td>
      ,
      <td
        className={` ${
            item?.hours7Style === COMPLIANCE_STATUS.expired
            ? 'text-red-700'
            : item?.hours7Style === COMPLIANCE_STATUS.upcoming || item?.hours7Style === COMPLIANCE_STATUS.current
              ? 'text-yellow-500'
              :item?.hours7Style ||item?.hours7Style ==COMPLIANCE_STATUS.compliant? 'text-green'
              : 'text-gray-700'
              }`}
            >
              {item.hours7Display}
        </td>
      ,
         <td
            className={` ${
            item?.hours14Style === COMPLIANCE_STATUS.expired
            ? 'text-red-700'
            : item?.hours14Style === COMPLIANCE_STATUS.upcoming || item?.hours14Style === COMPLIANCE_STATUS.current
              ? 'text-yellow-500'
              :item?.hours14Style ||item?.hours14Style ==COMPLIANCE_STATUS.compliant? 'text-green'
              : 'text-gray-700'
              }`}
            >
              {item.hours14Display}
        </td>
    ];
  });

  const aircraftHeaders = [
    { label: 'Pilot Hour ' },
    { label: 'Rests (days)' },
    { label: '7 Days (hrs) ' },
    { label: '14 Days (hrs)' },
  ];

  //TODO: I will update this any to right type

  const handleEdit = () => setEditMode(true);
  const handleCancel = () => setEditMode(false);
  const handleSave = () => {
    setEditMode(false);
  };
  const dateTime = formatDateToDDMMYYYY(getAdjustedDate());
  

  return (
    <>
      <div className="ml-6 mr-4">
        <ComplianceSection
          title={`Pilot Summary ${dateTime}`}
          headers={aircraftHeaders}
          rows={aircraftRows}
          updatedAllocations={updatedAllocations}
          isEditMode={isEditMode}
          isEdit={isEdit}
          onEditClick={handleEdit}
          onCancel={handleCancel}
          onSave={handleSave}
          driverAccordionIsOpen={driverAccordionIsOpen}
        />
      </div>
    </>
  );
};

export default PilotSummary;
